import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../util/currency';
import { createSlug } from '../../util/urlHelpers';
import { formatThisYearDateToShorter } from '../../util/dates';
import { NamedLink, ResponsiveImage } from '../../components';

import css from './OrderDetails.css';

const OrderDetails = ({
  providerName,
  listings = [],
  intl,
  actualOrderedProducts = [],
  transaction,
  children,
  codeMessage,
  titleMessage,
  transactionStatusAttributes = {}
}) => {
  if (!transaction) return null;
  const { end, start, code } = transaction.attributes || {};
  const isInternalUse = !!transaction.attributes?.internalUse;

  return (
    <div className={css.container}>
      <div className={classNames(css.titleContainer, css.title)}>
        <p className={css.title}>
          <FormattedMessage id={titleMessage} values={{ providerName }} />
          {code && (
            <span className={css.code}>
              <FormattedMessage id={codeMessage} />
              <span className={css.codeValue}>{` ${code}`}</span>
            </span>
          )}
          {isInternalUse && (
            <span className={css.internalUseBadge}>
              Wypożyczenie wewnętrzne
            </span>
          )}
        </p>
        <div className={classNames(css.statusText, transactionStatusAttributes.class)}>
          <FormattedMessage id={transactionStatusAttributes.textStatus} />
        </div>
        {transaction.attributes?.stolen && (
          <div className={classNames(css.statusText, css.stolen)}>
            <FormattedMessage id="OrderDetails.stolenStatus" />
          </div>
        )}
      </div>
      {children}
      <div className={css.mainContent}>
        {actualOrderedProducts.map(({ listingId, lineTotal, seats }) => {
          const listing = listings.find(({ id }) => id?.uuid === listingId);
          
          if (!listing) return null;

          const uuid = listing.id.uuid;
          const image = listing.images?.[0];
          const { title = '', deleted } = listing.attributes || {};
          const params = { id: listingId, slug: createSlug(title) };

          const imageContent = image && (
            <ResponsiveImage
              rootClassName={css.rootForImage}
              image={image}
              alt={title || 'product'}
              variants={["square-small", "square-small2x"]}
            />
          );

          return (
            <div
              className={classNames(css.productContainer, { [css.overlay]: !seats })}
              key={uuid || listingId}
            >
              {imageContent && (
                !deleted ? (
                  <NamedLink name="ListingPage" params={params} className={css.imageLink}>
                    {imageContent}
                  </NamedLink>
                ) : (
                  imageContent
                )
              )}

              <div className={css.productContent}>
                {!deleted ? (
                  <NamedLink name="ListingPage" params={params} className={css.productName}>
                    {title}
                  </NamedLink>
                ) : (
                  <p className={css.productName}>{title}</p>
                )}

                <div className={css.productDetails}>
                  <p className={css.text}>
                    <FormattedMessage id="DetailOrder.quantity" /> <b> {seats}</b>
                  </p>
                  <p className={css.text}>
                    <FormattedMessage id="DetailOrder.when" />{` `}
                    <b>
                      {`${formatThisYearDateToShorter(intl, moment(start))} - ${formatThisYearDateToShorter(intl, moment(end).subtract(1, 'days'))}`}
                    </b>
                  </p>
                  <p className={classNames(css.text, css.price)}>{formatMoney(intl, lineTotal)}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderDetails;